// extracted by mini-css-extract-plugin
module.exports = {"event":"_22zNI2RNCbG2xDmSE2GQg_","unsolved":"zOtx0Cul7PWL_XQcchqyp","solved":"_1qSZdyLWr8JNqfCtify-qz","date":"_38Os3f9jl7zDP3Z51p-swR","status":"_2Ky3D3BEUPw8pHouaQPBAu"};